var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"container_completed"}},[_c('v-card',[_c('v-card-text',[_c('v-row',[_c('v-col',[_c('b',[_vm._v("Vielen Dank für Ihre Anmeldung!")])])],1),_c('v-row',[_c('v-col',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }